module.exports = __webpack_public_path__ + "b9d0538a806428418285a7c29599737e.png";